var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNouser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-517 367)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(517 -367)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-3.342 -5.435)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 17.659,
    cy: 17.195,
    rx: 17.659,
    ry: 17.195,
    transform: "translate(552.183 -343.158)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M71.241,29.927C68.1,23.636,62.154,18.393,54.465,15.248a7.826,7.826,0,0,0-6.291.35A20.791,20.791,0,0,1,36.99,18.743,20.791,20.791,0,0,1,25.806,15.6a7.865,7.865,0,0,0-6.291,0C11.826,18.743,5.884,23.985,2.739,30.276c-2.447,4.544,1.4,9.786,6.641,9.786H64.6C69.843,40.063,73.688,34.82,71.241,29.927Z",
    transform: "translate(533.016 -319.817)",
    fill: "#b2b2b2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNouser);
export default __webpack_public_path__ + "static/media/nouser.27ee92f2c319c7e0e4fa17b2d2354c3b.svg";
export { ForwardRef as ReactComponent };